module.exports = __webpack_public_path__ + "img/chair_hot_off.e394eb56.png";